import React from 'react';

function NoLayer() {
  return (
    <div
      id="nolayer-wrapper"
      data-testid="nolayer-wrapper"
      className="flex-xy-center"
      style={{
        height: '5rem',
        width: '5rem',
        background: '#E0E0E0',
        border: '1px solid #BDBDBD',
        borderRadius: '0.375rem',
        color: '#858585',
        fontSize: '0.625rem',
        lineHeight: '0.69rem',
        padding: '0px 0.94rem',
      }}
    >
      <div id="nolayer-heading" data-testid="nolayer-heading" className="flex-x-center">
        No Layer Added
      </div>
    </div>
  );
}

export default NoLayer;
